import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "regenerator-runtime/runtime.js";
import _typeof from "@babel/runtime/helpers/typeof";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import $ from 'zepto';
import searchObj from './searchToObj';
import throttle from '@/utils/throttle';
import env from 'drip';
import URL from 'drip/utils/url';
import Cookie from 'drip/utils/cookie';
import Drip from 'drip';
import Geo from 'drip/geo';
var ACTIVITY_TAG = env.activityTag;
var appIdentify = {
  1: 'dianping_nova',
  2: 'movie',
  3: 'dianping_movie_wx',
  5: 'movie',
  6: 'maoyan_wxwallet_i',
  7: 'maoyan_wxwallet_i',
  13: 'yanchu_qqwallet_i',
  22: 'TJAPP',
  28: 'yanchu_qqwallet_i'
};
var cookieDomain = {
  maoyan: '.maoyan.com',
  dianping: '.dianping.com',
  dianpingTest: '.51ping.com',
  localhost: 'localhost'
};
var utmKeys = ['utm_source', 'utm_medium', 'utm_term', 'utm_content', 'utm_campaign'];
var isFirstOnLoad = true;
export function viewStats(e) {
  var eles = document.querySelectorAll(e.target.id ? "#".concat(e.target.id, " .scroll-view-stats") : '.scroll-view-stats');
  eles = Array.prototype.slice.call(eles, 0);
  eles.forEach(function (ele) {
    try {
      var _ref = ele.dataset || {},
          _ref$view_bid = _ref.view_bid,
          view_bid = _ref$view_bid === void 0 ? '' : _ref$view_bid,
          custom = _ref.custom,
          view_seed = _ref.view_seed;

      var bidObj = {};

      try {
        view_seed = JSON.parse(view_seed);
        bidObj = Object.assign({}, view_seed);
      } catch (error) {
        view_seed = null;
      }

      if (!view_bid && view_seed && view_seed.viewBid) {
        view_bid = view_seed.viewBid;
      }

      if (!custom && view_seed && view_seed.custom) {
        custom = view_seed.custom;
      }

      if (!view_bid) return false;
      if (!isEleInView(ele)) return false;
      seedAction(Object.assign({}, bidObj, {
        evt: 'view',
        bid: view_bid,
        custom: custom || {}
      }));
    } catch (error) {}
  });
}
window.StatusReportData = throttle(viewStats, 600); // 判断元素是否在视图区内

function isEleInView(ele) {
  var viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
  var viewWidth = Math.max(document.documentElement.clientWidth, window.innerWidth);

  var _ele$getBoundingClien = ele.getBoundingClientRect(),
      x = _ele$getBoundingClien.x,
      y = _ele$getBoundingClien.y,
      width = _ele$getBoundingClien.width,
      height = _ele$getBoundingClien.height;

  return x >= 0 && y >= 0 && x + width / 2 <= viewWidth && y + height / 2 <= viewHeight;
}

window.lxTagReport = function (cid, mcBid) {
  var lab = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  Analytics('tag', 'movie', _defineProperty({}, cid, Object.assign({
    bid: mcBid
  }, lab)));
}; // viewEvt: 页面是否上报曝光事件


var analytics = function analytics(pgId) {
  var uid = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var appName = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'dianping_nova';
  var viewEvt = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  options = Object.assign({}, {
    autoSendPv: true
  }, options);

  function setGlobalCustom() {
    return _setGlobalCustom.apply(this, arguments);
  }

  function _setGlobalCustom() {
    _setGlobalCustom = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _Drip$constant$cityId, cityId, globalCustom, localObj;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // 打点自动配置city_id和gcity_id
              _Drip$constant$cityId = Drip.constant.cityId, cityId = _Drip$constant$cityId === void 0 ? 1 : _Drip$constant$cityId;
              globalCustom = {
                city_id: cityId,
                gcity_id: cityId
              };
              options.global = Object.assign({}, globalCustom, options.global || {}, options.custom || {});
              _context.next = 5;
              return Geo.getLocCity();

            case 5:
              localObj = _context.sent;

              if (localObj && localObj.cityId) {
                localObj;
                options.global.gcity_id = localObj.cityId;
              }

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _setGlobalCustom.apply(this, arguments);
  }

  setGlobalCustom(); // 以上Analytics字符串为导出到window上的函数，该函数为全局函数可在页面JS代码初始化时调用
  // 设置应用名称，3.0版本(sdk_ver)开始 Web SDK 会自动检测以下客户端的内嵌页面。
  // 自动检测列表: 团购(group)、点评(dianping_nova)、猫眼(movie)客户端、猫眼专业版(moviepro)客户端
  // 如果你需要将你的客户端加入自动白名单中，请联系 wangqiang18 或 zhangwei30

  var appIdentifier = env.constant && env.constant.appType ? appIdentify[+env.constant.appType] : 'dianping_movie_m';
  Analytics('config', 'appnm', appIdentifier);

  if (!uid || uid && '' === uid) {
    uid = 0;
  } //设置应用上报通道标识与uid


  Analytics('use', 'movie', {
    uid: uid
  }); // 设置页面的 cid

  Analytics('config', 'cid', pgId);
  /* ******* 手动设置 utm 开始 ********  */
  // 第一次打开清空 utm的cookie

  if (isFirstOnLoad) {
    var domain = '';

    for (var _i = 0, _Object$values = Object.values(cookieDomain); _i < _Object$values.length; _i++) {
      var value = _Object$values[_i];

      if (location.host.indexOf(value) !== -1) {
        domain = value;
      }
    }

    Cookie.set('_lx_utm', '', {
      path: '/',
      expires: '',
      domain: domain
    });
    isFirstOnLoad = false;
  }

  var oldUtm = {};
  var oldUtmCookie = Cookie.get('_lx_utm');

  if (oldUtmCookie) {
    oldUtm = URL.parseQuery(oldUtmCookie);
  } // url base中的的query


  var urlSearch = URL.query2Object(); // 兼容 fromTag TODO bd全部切换后 可以去去掉

  var utmUrlFromTag = {};
  var urlFromTag = urlSearch[ACTIVITY_TAG.FROM_TAG];
  if (urlFromTag) utmUrlFromTag.utm_source = urlFromTag;
  var urlSearchKeys = Object.keys(urlSearch);
  urlSearchKeys.forEach(function (key) {
    if (!utmKeys.includes(key)) {
      delete urlSearch[key];
    }
  }); // url hash中的的query

  var arrayHashQuery = [];

  if (location.hash) {
    arrayHashQuery = location.hash.split('?');
  }

  var HashQueryString = arrayHashQuery.length === 2 ? arrayHashQuery[1] : '';
  var urlHashQuery = URL.parseQuery(HashQueryString); // 兼容 fromTag TODO bd全部切换后 可以去去掉

  var utmUrlHashFromTag = {};
  var urlHashFromTag = urlHashQuery[ACTIVITY_TAG.FROM_TAG];

  if (urlHashFromTag) {
    utmUrlHashFromTag.utm_source = urlHashFromTag;
  }

  var urlHashQueryKeys = Object.keys(urlHashQuery);
  urlHashQueryKeys.forEach(function (key) {
    if (!utmKeys.includes(key)) {
      delete urlHashQuery[key];
    }
  });
  var utm = Object.assign({}, oldUtm, utmUrlFromTag, urlSearch, utmUrlHashFromTag, urlHashQuery);
  Analytics('set', 'utm', utm);
  /* ******* 手动设置 utm 结束 ********  */

  window.seedPvAction = function () {
    var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : options.custom || {};
    if (_typeof(opt) !== 'object') throw new Error('Augument must be an Object'); // 发送pv，其中"page_cid"为页面名称，你应该为你的每一个页面起一个唯一的名称
    // 如果调用此行代码前设置过 cid ( Analytics('config', 'cid', 'page_cid') ) 可以不设置 page_cid
    // 请确保在 use 方法之后调用 send 方法

    var custom = Object.assign(opt, {
      fromTag: searchObj && searchObj.fromTag ? searchObj.fromTag : 0 // 这里设置自定义埋点信息

    });
    Analytics('send', 'pv', {
      act: 'pageview',
      cid: pgId,
      ref: document.referrer,
      val: {
        custom: custom
      }
    });
  };

  window.seedAction = function (data) {
    var opts = {
      nm: 'mge',
      val_bid: data.bid,
      event_type: data.evt || 'click',
      element_id: data.id || ''
    };
    data.name && (opts.val_lab = {
      _name: data.name
    });
    options.global && (opts.val_lab = Object.assign(opts.val_lab || {}, options.global));
    data.custom && (opts.val_lab = Object.assign(opts.val_lab || {}, data.custom));
    data.index && (opts.index = data.index);
    data.cid && (opts.cid = data.cid);
    data.abtest !== undefined && (opts.abtest = data.abtest);
    Analytics('event', opts);
  }; // 外界去重置utm的方法


  window.resetUTMAction = function (utm) {
    Analytics('set', 'utm', utm);
  };

  options.autoSendPv && seedPvAction(); // Analytics('send', 'pv', {
  //     act : 'pageview',
  //     cid : pgId,
  //     ref : document.referrer,
  //     val : {
  //         custom: {// val_val 满足不了的信息
  //             fromTag:  searchObj && searchObj.fromTag ? searchObj.fromTag : 0// 这里设置自定义埋点信息
  //         }
  //     }
  // });
  // 打点处理

  $('body').on('click', '[data-seed]', function (e) {
    var seed = $(this).data('seed');
    var obj = {};

    if (Object.prototype.toString.call(seed).slice(8, -1) === 'Object') {
      obj = seed;
    } else {
      try {
        obj = JSON.parse(seed);
      } catch (error) {
        var strTrim = function strTrim(str) {
          return str.replace(/\'|\"/g, '').trim();
        };

        seed.split(',').forEach(function (v) {
          var temp = v.split(':');
          obj[strTrim(temp[0])] = strTrim(temp[1]);
        });
      }
    }

    if (!obj.bid) return;
    seedAction(obj);
  });
  window.removeEventListener('scroll', window.StatusReportData);

  if (viewEvt) {
    window.addEventListener('scroll', window.StatusReportData, false);
  }
};

export default analytics;